import { forwardRef, useState } from "react";
import { motion } from "motion/react";
import classNames from "classnames/bind";
import { Container, Button } from "@components";
import TopLevelLink from "./Links/TopLevelLink";
import { GetPageWrapperDataQuery } from "@graphqlTypes";
import MenuAccordion from "./MenuAccordion/MenuAccordion";

import styles from "./MobileMenu.module.scss";
import { getLinkData } from "@/core/utils";
import InlineLink from "./Links/InlineLink";
import LanguageRadioSelect from "../LanguageRadioSelect/LanguageRadioSelect";
const cx = classNames.bind(styles);

type MobileMenuProps =
  SiteNavigation["navigationSettingsFields"] & {
    languages: GetPageWrapperDataQuery["languages"];
  };

const ComponentMap: { [key: string]: React.ComponentType<any> } = {
  link: TopLevelLink,
  dropdown: MenuAccordion,
};

const MobileMenu = forwardRef<HTMLDivElement, MobileMenuProps>((props, ref) => {
  const {
    topLevelNavigation,
    ticketsCta,
    donateLink,
    membershipLink,
    hostEventLink,
    languages,
  } = props;
  const [activeAccordion, setActiveAccordion] = useState<string | null>(null);
  const onToggle = (id: string) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  const ticketsLinkData = getLinkData(ticketsCta);
  const links = [membershipLink, donateLink, hostEventLink].filter(Boolean);
  return (
    <div className={cx("mobile-menu")} ref={ref}>
      <Container className={cx("container")}>
        {topLevelNavigation?.map((item, index) => {
          if (!item) return null;
          const Component = ComponentMap[item.type?.[0]];
          if (!Component) return null;
          return (
            <Component
              key={index}
              {...item}
              index={index}
              isOpen={activeAccordion === `menu-accordion-item-${index}`}
              onToggle={onToggle}
            />
          );
        })}
        {ticketsLinkData && (
          <Button className={cx("tickets-cta")} {...ticketsLinkData} noIcon dataGtmSection="nav" />
        )}
        <div className={cx("links")}>
          {links.map((link, index) => (
            <InlineLink key={index} {...link} />
          ))}
        </div>
        <LanguageRadioSelect languages={languages} />
      </Container>
    </div>
  );
});

export default motion.create(MobileMenu);
